import Image from 'next/image'

import LinkButton from 'shared/ui/Button/LinkButton'
import { PATHS } from 'shared/utils/paths'

import styles from './LandingMobileButtonsSection.module.scss'

const LandingMobileButtonsSection = () => {
  return (
    <section className={styles.wrapper}>
      <LinkButton
        href={PATHS.newestProducts}
        size='large'
        variant='tertiary'
        fullWidth
        startIcon={
          <Image
            src={'/static/icons/surprise-gift.svg'}
            alt=''
            width={24}
            height={24}
          />
        }
      >
        Nowości
      </LinkButton>
      <LinkButton
        href={PATHS.bestsellers}
        size='large'
        variant='secondary'
        fullWidth
        startIcon={
          <Image src={'/static/icons/star.svg'} alt='' width={24} height={24} />
        }
      >
        Specjały
      </LinkButton>
    </section>
  )
}

export default LandingMobileButtonsSection
